import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=0e9a474c&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=0e9a474c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9a474c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9a474c')) {
      api.createRecord('0e9a474c', component.options)
    } else {
      api.reload('0e9a474c', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=0e9a474c&scoped=true&", function () {
      api.rerender('0e9a474c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/contact.vue"
export default component.exports